import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 19,
    type: CHECKLIST_ITEM_TYPE.START_TREATMENT,
    manifestKey: 'START_TREATMENT',

    try_it: {
        button_label: 'Start Treatment',
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'StartTreatmentCell',
        },
        prefill: {
            completion_state: 'YES',
            response_payload: { treatment_id: 'demo-treatment-001' },
        },
    },
    pre_flight_diff: [
        'Treatment start triggers via POST /treatments/{id}/treatment_started/',
        'Lead status: CONSULTATION_ATTENDED → TREATMENT_STARTED',
        'Checklist item: PENDING → YES',
        'TaskActivity row created with action CHECKLIST_ITEM_COMPLETED',
        '⚠ Payment enforcement: if is_payment_enforced_before_treatment, error may be swallowed on FE',
        'Role gate: ADMIN or TCO only — USER role returns 403',
    ],
    has_step2_throttle: true,
    validation_laboratory: null,
};
